import { useNavigate } from "react-router-dom";

export default function CardComponent({ el }) {
  let navigate = useNavigate();

  function cardButton(e) {
    e.preventDefault();
    navigate(`/detail/${el.id}`);
  }
  return (
    <>
      <div
        className="max-w-sm rounded overflow-hidden shadow-lg cursor-pointer"
        key={el.id}
        onClick={cardButton}
      >
        <img className="w-full" src={el.imgUrl} />
        <div className="px-6 py-4">
          <div className="font-bold text-xl mb-2">{el.title}</div>
        </div>
        <div className="px-6 pt-4 pb-2">
          <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
            rating {el.rating}
          </span>
          <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
            {el.Genre.name}
          </span>
        </div>
      </div>
    </>
  );
}
